__webpack_require__.p = "https://petdna-lihp.pages.dev/";